module.exports = __webpack_public_path__ + "img/Volterres_120X35.b89e3b93.png";